import { useContext, useState } from 'react';
import { CircularProgress, TextField } from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import _ from 'lodash';
import { ISCAutocompleteResponse } from 'helpers/interfaces';
import { applicationContext } from 'helpers/services';
import { KeyValuePair } from 'helpers';


interface IProps {
    value: IProductResponse
    label: string
    freeSolo: boolean
    error?: boolean
    helperText?: string
    margin?: 'dense' | 'none' | 'normal'

    onChange: (sku: string, brand: string, description: string, hasSerialNumber: boolean, suppliers: KeyValuePair<string, string>[]) => void
}

interface IProductResponse extends ISCAutocompleteResponse<string> {
    sku: string
    brand: string
    shortDescription: string
    hasSerialNumber: boolean
    suppliers: KeyValuePair<string, string>[]
}

let ProductSearch = (props: IProps) => {
    var etag = 0;

    let [isLoading, setLoading] = useState(false);
    let [open, setOpen] = useState(false);
    let [options, setOptions] = useState<IProductResponse[]>([]);

    let { searchProducts } = useContext(applicationContext);

    let filter = createFilterOptions<any>();

    let startSearch = _.debounce(async (e: any, searchTerm: string, reason: string) => {
        if (reason === "input")
            await doSearch(searchTerm)
    }, 500);

    let doSearch = async (searchTerm: string) => {
        setLoading(true)

        etag = etag + 1

        let response = await searchProducts(searchTerm, etag);
        if (response && response.etag === etag) {
            setOptions(response.items);
            setOpen(true);
        }
        setLoading(false);
    }


    return (
        <Autocomplete
            freeSolo={props.freeSolo}
            loading={isLoading}
            open={open}
            fullWidth
            value={props.value}
            onClose={() => {
                setOpen(false);
                setOptions([]);
            }}
            onChange={(event: any, newValue: any) => {
                if (typeof newValue === 'string') {
                    props.onChange(newValue || '', '', '', false, [])
                } else {
                    props.onChange(newValue?.sku || '', newValue?.brand || '', newValue?.shortDescription || '', newValue?.hasSerialNumber || false, newValue?.suppliers || [])
                }
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                if (props.freeSolo
                    && isLoading === false
                    && options.length === 0
                    && params.inputValue !== '') {

                    filtered.push({
                        brand: '',
                        label: `Choose "${params.inputValue}"`,
                        shortDescription: '',
                        value: params.inputValue,
                        sku: params.inputValue
                    });
                }

                return filtered;
            }}
            onInputChange={startSearch}
            options={options}
            getOptionSelected={(option, value) => option.value === value.sku}
            getOptionLabel={(option) => option.label}
            renderOption={(option: ISCAutocompleteResponse<any>, { inputValue }) => {
                let matches = match(option.label, inputValue);
                let parts = parse(option.label, matches);

                return (
                    <div>
                        {parts.map((part: any, index: number) => (
                            <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                            </span>
                        ))}
                    </div>
                )
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    variant="outlined"
                    margin={props.margin}
                    error={props.error}
                    helperText={props.helperText}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default ProductSearch;